import type { ReactNode } from 'react';
import { UserIcon, CalendarIcon } from '@heroicons/react/24/solid';
import { MANAGER_LABEL, buildRequestedAtLabel } from '../vacationRequestSummary.definitions';

interface SummaryApprovalProps {
    managerEmail: string | null;
    managerName?: string | null;
    requestedAt: string | null;
    children?: ReactNode;
}

export function SummaryApproval({ managerEmail, managerName, requestedAt, children }: SummaryApprovalProps) {
    if (!managerEmail && !requestedAt && !children) return null;

    return (
        <div className="rounded-2xl border border-raro-gray-100 p-4 space-y-3">
            {(managerEmail || requestedAt) && (
                <div className="flex flex-wrap items-center justify-between gap-x-6 gap-y-2">
                    {managerEmail && (
                        <div className="flex items-center gap-3 min-w-0">
                            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-100">
                                <UserIcon className="h-5 w-5 text-primary-600" />
                            </div>
                            <div className="min-w-0">
                                <p className="text-xs text-raro-gray-500 font-montserrat">{MANAGER_LABEL}</p>
                                <p className="text-sm font-semibold text-raro-gray-900 font-montserrat">
                                    {managerName ?? managerEmail}
                                </p>
                                {managerName && (
                                    <p className="text-xs text-raro-gray-500 font-montserrat">{managerEmail}</p>
                                )}
                            </div>
                        </div>
                    )}
                    {requestedAt && (
                        <div className="flex shrink-0 items-center gap-2 text-raro-gray-500">
                            <CalendarIcon className="h-4 w-4" />
                            <p className="text-xs font-montserrat">{buildRequestedAtLabel(requestedAt)}</p>
                        </div>
                    )}
                </div>
            )}
            {children}
        </div>
    );
}

export default SummaryApproval;
